// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".student-admission-detail-board-main > div[data-v-aec9a0b6] {\n  border-left: 5px solid #FF7058;\n  height: 370px !important;\n}\n@media (max-width: 767px) {\n.student-admission-detail-board-main > div[data-v-aec9a0b6] {\n    height: 100% !important;\n}\n}\n.pointer[data-v-aec9a0b6] {\n  cursor: pointer;\n}\n.fs-14[data-v-aec9a0b6] {\n  font-size: 14px;\n}\n.fs-16[data-v-aec9a0b6] {\n  font-size: 16px;\n}\n.text-dark-gray[data-v-aec9a0b6] {\n  color: #3f5b60;\n}", ""]);
// Exports
module.exports = exports;
